export default "__VITE_ASSET__7ccnOBbg__ 1920w";